import React, { forwardRef, useRef } from "react";

// The row stores raw draft text; lookup/formatting belongs to explicit commit.
const FabricTextInput = forwardRef(function FabricTextInput({ value, onChange, onBlur, onCommit, onCommitError, onKeyDown, ...props }, ref) {
  const composing = useRef(false);
  const reportCommitError = error => {
    if (onCommitError) onCommitError(error);
    else console.error("Fabric input commit failed");
  };
  const commit = text => {
    try {
      Promise.resolve(onCommit?.(text)).catch(reportCommitError);
    } catch (error) {
      reportCommitError(error);
    }
  };
  return <input {...props} ref={ref} value={String(value ?? "")}
    onChange={onChange}
    onCompositionStart={() => { composing.current = true; }}
    onCompositionEnd={() => { composing.current = false; }}
    onBlur={event => { onBlur?.(event); commit(event.target.value); }}
    onKeyDown={event => {
      if (composing.current || event.nativeEvent?.isComposing) return;
      onKeyDown?.(event);
      if (event.key === "Enter" && !event.defaultPrevented) {
        event.preventDefault();
        commit(event.currentTarget.value);
      }
    }} />;
});

export default FabricTextInput;
